<div class="charge-general">
	<div class="charge-general__title-block">
		@if (charge.description) {
			<h4
				class="charge-general__title"
				title="{{ charge.description }}"
			>
				{{ charge.description }}
			</h4>
		}
		@if (charge.payeeName) {
			<div class="charge-general__payee-name">
				{{ charge.payeeName }}
			</div>
		}
		@if (charge.subscriptionNumber) {
			<div class="charge-general__subscription-number">
				{{ charge.subscriptionNumber }}
			</div>
		}
	</div>
	<div class="charge-general__row">
		<div class="charge-general__value">
			<p class="charge-general__price">
				{{ getAmountToPay() | amountincurrency }}
			</p>
			@if (charge.discountInfo) {
				<p class="charge-general__price charge-general__price--sale">
					{{ charge.amount | amountincurrency }}
				</p>
			}
		</div>
		<div class="charge-general__pay-block">
			@if (!charge.status || charge.status === 'NEW_ACCRUAL') {
				<app-route-action-link [action]="this.action"></app-route-action-link>
			} @else {
				<span class="color-status color-status--in-progress">В процессе оплаты</span>
			}
		</div>
		<div class="charge-general__info">
			<p class="charge-general__text">
				Выставлен {{ charge.createDate | date: 'dd MMMM yyyy' }} года
			</p>
			@if (charge.discountInfo) {
				<p class="charge-general__text charge-general__text--sale">
					<span class="charge-general__sale-count">
						{{ charge.discountInfo.discount }}%
					</span>
					до&nbsp;{{
						charge.discountInfo.discountExpiresDate | date: 'dd MMMM yyyy'
					}}&nbsp;года
				</p>
			}
		</div>
	</div>
</div>
